import type { Ref } from 'vue';
export default function (
  itemContainer: Ref<HTMLElement | undefined>,
  resetWidth: Ref<number>
) {
  let startX = 0;
  let deviation = 0;
  let startPosition = 0;
  let timer: NodeJS.Timer | null = null;
  const translateX = ref(0);
  const stopAutoSwitch = ref(false);
  const touchstartCallback = (e: TouchEvent) => {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    stopAutoSwitch.value = true;
    const { touches } = e;
    startX = touches[0].pageX;
    startPosition = translateX.value;
  };
  const touchmoveCallback = (e: TouchEvent) => {
    const width = Math.floor(resetWidth.value);
    const { changedTouches } = e;
    const endX = changedTouches[0].pageX;
    const distance = endX - startX;
    let result = Math.floor(startPosition + distance);
    if (result >= 0) {
      startPosition = result = 0;
      deviation = distance;
      translateX.value = startPosition = width;
    }
    if (result < width) {
      deviation = distance;
      translateX.value = startPosition = 0;
    }
    translateX.value = result - deviation;
  };
  const touchendCallback = () => {
    timer = setTimeout(() => {
      stopAutoSwitch.value = false;
    }, 1000);
    deviation = 0;
  };
  function createListeners() {
    itemContainer.value?.addEventListener('touchstart', touchstartCallback);
    itemContainer.value?.addEventListener('touchmove', touchmoveCallback);
    itemContainer.value?.addEventListener('touchend', touchendCallback);
  }
  function removeListeners() {
    itemContainer.value?.addEventListener('touchstart', touchstartCallback);
    itemContainer.value?.addEventListener('touchmove', touchmoveCallback);
    itemContainer.value?.addEventListener('touchend', touchendCallback);
  }
  onMounted(createListeners);
  onUnmounted(removeListeners);

  return {
    translateX,
    stopAutoSwitch,
  };
}
